import { ReactNode } from 'react';

import { useAmpContext } from 'utils/AmpContext';

type Props = {
  children: ReactNode;
};

export function NoAmp({ children }: Props) {
  const isAmp = useAmpContext();

  if (isAmp) return null;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
